export default __webpack_public_path__ + "static/media/modal-close-icon.8ccfc7fb.svg";